import { useEffect } from 'react';

// NOTE: pass id of element in 'exceptions' array.
function useClickOutside(elementRef, handler, exceptions = []) {
  useEffect(() => {
    function clickedOutside(e) {
      if (elementRef.current && !elementRef.current.contains(e.target)) {
        exceptions.forEach((exception) => {
          const exceptionEl = document.querySelector(`#${exception}`);

          if (exceptionEl?.contains(e.target)) {
            return;
          }
        });

        handler(e);
      }
    }

    document.addEventListener('click', clickedOutside);

    return () => document.removeEventListener('click', clickedOutside);
  }, [handler, elementRef]);
}

export default useClickOutside;
